var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[(_vm.comment)?_c('i',{directives:[{name:"popover",rawName:"v-popover",value:(_vm.popover),expression:"popover"}],staticClass:"fa-regular fa-comment"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }